import React, {Component} from 'react'
import {isEqual} from 'lodash'
import PropTypes from 'prop-types'
import {SearchToSelect} from "../../components/selector/SearchToSelect";
import * as usersApi from "./usersApi";
import {Username} from "./components/Username";


export class UserSelector extends Component {

  static propTypes = {
    selected: PropTypes.any,
    onSelected: PropTypes.func,
    getUserSearchParams: PropTypes.func,
    filterAvailableUsers: PropTypes.func
  }


  static renderUser(user) {
    return <Username chipSize="sm" user={{...user, userId: UserSelector.getKey(user) }}/>
  }


  static getSearchResults({
    query, offset
  }) {
    return usersApi.listUsers({
      query, offset
    }).then(({ users, hasMore }) => {
      return ({ items: users, hasMore: hasMore })
    });
  }

  static getKey(user) {
    return user.id || user.userId
  }

  render() {
    return <SearchToSelect
      {...this.props}
      getSearchResults={(params) => {
        const {getUserSearchParams} = this.props;
        params = getUserSearchParams ? getUserSearchParams(params) : params;
        return UserSelector.getSearchResults(params)
      }}
      getKey={UserSelector.getKey}
      renderOption={this.props.renderOption || UserSelector.renderUser}
    />
  }
}
